import "./custom/sentry"
import "@hotwired/turbo-rails"
import "./custom/stream_actions"
import "./custom/birthdate_input"
import * as bootstrap from "bootstrap"

import {application} from "./controllers/application"

import TomSelectController from "./controllers/tom_select_controller"
import PublicSubscriptionFormController from "./controllers/public_subscription_form_controller"
import PublicDiscountsController from "./controllers/public_discounts_controller"
import PublicPaymentMethodController from "./controllers/public_payment_method_controller"
import SubscriptionTypeSelectorController from "./controllers/subscription_type_selector_controller"
import RevealController from "./controllers/reveal_controller"
import PasswordToggleController from "./controllers/password_toggle_controller"

application.register("tom-select", TomSelectController)
application.register("public-subscription-form", PublicSubscriptionFormController)
application.register("public-discounts", PublicDiscountsController)
application.register("public-payment-method", PublicPaymentMethodController)
application.register("subscription-type-selector", SubscriptionTypeSelectorController)
application.register("reveal", RevealController)
application.register("password-toggle", PasswordToggleController)

function initializeBootstrapComponents() {
    // Tooltips and popovers
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => bootstrap.Tooltip.getOrCreateInstance(el));
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => bootstrap.Popover.getOrCreateInstance(el));
}

// Only run this *after* full DOM render
document.addEventListener("DOMContentLoaded", () => {
    initializeBootstrapComponents();
});

document.addEventListener("turbo:load", () => {
    initializeBootstrapComponents();
});

document.addEventListener("turbo:submit-end", (event) => {
    // wait for the request to render the DOM
    setTimeout(initializeBootstrapComponents, 1000)
});
